<template>
  <div class="bg-gray full-height">
   <navigation-bar />
    <div class="container-fluid">
      <div class="row" style="padding-top:20px;">
        <div class="col-sm-5 col-centered">
          <div class="white-panel" style="margin-bottom: 0px;">
            <h1>Forgot password</h1>
            <div class="row" style="margin-top:20px;">
              <div v-if="submitted" class="col-xs-12 col-sm-12" >
                <div class="alert alert-success" role="alert">
                    Submitted! Please check your email for instructions
                  </div>
              </div>
              <div v-else class="col-xs-12 col-sm-12">
                <p>Enter your email address below and we'll send you an email with instructions to reset your password.</p>
                <div class="form-group">
                  <input v-model="email" class="form-control" placeholder="Email">
                </div>
                <div class="form-group">
                  <button v-on:keyup.enter="forgotSubmit" v-on:click="forgotSubmit" style="width:100%;" class="btn btn-primary btn-blue">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from '@/components/nav/NavigationBar'
import API from '@/API/API'
import DashboardFooter from '@/components/nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from './AccountSessionUtils'

export default {
  name: 'ForgotPassword',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      api: API,
      nav: Navigator,
      email: '',
      submitted: false,
      accountUtils: AccountSessionUtils,
    }
  },
  mounted() {
    this.accountUtils.authorize((userId) => {
      this.currentUserId = userId;
    },(err) => {
    }, () => {
        this.nav.goMaintenance(this)
    })
  },
  methods: {
    forgotSubmit: function() {

      if(this.email == ''){
        this.$toasted.show('Email is required', { type: 'error', duration: 2500 })
        return
      }

      let self = this
      this.api.forgotPassword(this.email)
      .then(function (res) {
        let resData = res.data;
        if("error" in resData){
          let error = resData.error;
          self.$toasted.show(error, { type: 'error', duration: 2500 })
        }else{
          self.submitted = true
          self.email = ''
        }
      })
      .catch(e => {
        self.$toasted.show(e, { type: 'error', duration: 2500 })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/ForgotPassword.vue